import { Star } from "lucide-react";
import { useEffect, useState } from "react";
import { useFieldContext } from "../../../../../question/components/organisms/FieldRenderer";



export function RatingRenderer() {
    const { question, setFormValue, disabled, response, currentValue } = useFieldContext();
    const [value, setValue] = useState<number>(0);

    useEffect(() => {
        if(currentValue) {
            setValue(currentValue);
        }
    }, [currentValue]);

    useEffect(() => {
        if (!disabled && setFormValue) {
            setFormValue(value.toString());
        }
    }, [setFormValue, value, disabled]);

    return (
        <div className="flex gap-1">
            {!disabled ? (
                <>
                    {Array.from({ length: question?.field_max || 5 })?.map((_, index) => (
                        <div key={index} className="flex items-center space-x-2">
                            <Star
                                onClick={() => {
                                    setValue(index + 1);
                                }}
                                color='text-yellow-500'
                                stroke="currentColor"
                                className={`w-5 h-5 cursor-pointer text-yellow-500 ${!disabled ? 'hover:text-yellow-600' : ''}`}
                                fill={index < value ? 'currentColor' : 'none'}
                            />
                        </div>
                    ))}
                </>
            ) : (
                <>
                    {Array.from({ length: question?.field_max || 5 })?.map((_, index) => (
                        <div key={index} className="flex items-center space-x-2">
                            <Star
                                color='text-yellow-500'
                                stroke="currentColor"
                                className={`w-5 h-5 text-yellow-500 ${!disabled ? 'hover:text-yellow-600' : ''}`}
                                fill={index < Number(response?.field_value) ? 'currentColor' : 'none'}
                            />
                        </div>
                    ))}
                </>
            )}
        </div>
    )
}